export default "__VITE_ASSET__DSLu$nSr__"